import { render, staticRenderFns } from "./GeneralReports.vue?vue&type=template&id=c0c06c82&scoped=true"
import script from "./GeneralReports.vue?vue&type=script&lang=js"
export * from "./GeneralReports.vue?vue&type=script&lang=js"
import style0 from "./GeneralReports.vue?vue&type=style&index=0&id=c0c06c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c06c82",
  null
  
)

export default component.exports